import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button, Col, Input, Label, Media, Pagination, PaginationItem, PaginationLink, PopoverBody, Row, Spinner, UncontrolledPopover,
} from 'reactstrap';
import { DateTimePicker } from 'react-widgets';
import { size } from 'lodash';
import { getCantJoinRoom, getCantJoinRoomCount } from '../../../actions/admin';
import { CANT_JOIN_ROOM_REASON, ENTERKEY, FORMAT_DATE_TYPE } from '../../../constants/constants';
import draugiemImg from '../../../images/icons/draugiem.svg';
import facebookImg from '../../../images/icons/facebook.svg';
import inboxImg from '../../../images/icons/inbox.svg';
import DateFormat from '../UI/DateFormat';

const AllPlayersHistoryToJoinRoom = ({ offset }) => {
  const dispatch = useDispatch();
  const [filterType, setFilterType] = useState('userId');
  const [filter, setFilter] = useState('');
  const [startDate, setStartDate] = useState(new Date(Date.now() - 24 * 60 * 60 * 1000));
  const [endDate, setEndDate] = useState(new Date());
  const [actionType, setActionType] = useState('all');
  const [reason, setReason] = useState('all');
  const [currentPage, setCurrentPage] = useState(0);
  const [isReset, setIsReset] = useState(false);
  const pageSize = 50;


  const allCantJoinRoom = useSelector(state => state.admin.cantJoinRoom || {});
  const allCantJoinRoomCount = useSelector(state => state.admin.cantJoinRoomCount || 0);

  useEffect(() => {
    dispatch(getCantJoinRoomCount(startDate, endDate));
    dispatch(getCantJoinRoom(startDate, endDate, actionType, reason, filterType, filter));
  }, []);

  const filterFunc = () => {
    if (Date.parse(startDate) > Date.parse(endDate)) return;

    setCurrentPage(0);
    dispatch(getCantJoinRoomCount(startDate, endDate));
    dispatch(getCantJoinRoom(startDate, endDate, actionType, reason, filterType, filter));
  };

  const resetFilters = () => {
    const newStartDate = new Date(Date.now() - 24 * 60 * 60 * 1000);
    const newEndDate = new Date();
    setActionType('all');
    setReason('all');
    setFilter('');
    setFilterType('userId');
    setStartDate(newStartDate);
    setEndDate(newEndDate);
    dispatch(getCantJoinRoomCount(newStartDate, newEndDate));
    dispatch(getCantJoinRoom(newStartDate, newEndDate, 'all', 'all', 'userId', ''));
    setIsReset(false);
  };

  const selectType = (e) => {
    if (e.target.value === filterType) return;
    setFilterType(e.target.value);
  };

  const selectActionType = (e) => {
    if (e.target.value === actionType) return;
    setActionType(e.target.value);
    if (e.target.value !== 'all') {
      setIsReset(true);
    }
  };

  const selectReason = (e) => {
    if (e.target.value === reason) return;
    setReason(e.target.value);
    if (e.target.value !== 'all') {
      setIsReset(true);
    }
  };

  const handleKeyPress = (target) => {
    if (target.charCode === ENTERKEY) {
      filterFunc();
    }
  };

  const handleChange = (event) => {
    if (event.target.value === filter) return;
    setFilter(event.target.value);
    if (event.target.value !== '') {
      setIsReset(true);
    }
  };

  const changeStartDate = (date) => {
    if (date === startDate) return;
    setStartDate(date);
    setIsReset(true);
  };

  const changeEndDate = (date) => {
    if (date === endDate) return;
    setEndDate(date);
    setIsReset(true);
  };

  const handleClick = (e, index) => {
    e.preventDefault();

    setCurrentPage(index);
  };

  const renderPlatformIcon = (platform) => {
    const platformInfo = platform ? platform.toLowerCase() : '';
    switch (platformInfo) {
      case 'draugiem':
        return <Media src={draugiemImg} className="allUsers-table-col-img" />;
      case 'facebook':
        return <Media src={facebookImg} className="allUsers-table-col-img" />;
      case 'inbox':
        return <Media src={inboxImg} className="allUsers-table-col-img" />;
      case 'android':
        return 'ANDROID';
      case 'ios':
        return 'IOS';
      case 'mweb':
        return 'WEB';
      case 'web':
        return 'WEB';
      default:
        return '';
    }
  };

  if (!allCantJoinRoom || (allCantJoinRoom && allCantJoinRoom.loading)) {
    return (
      <Spinner type="grow" color="warning" style={{ width: '2rem', height: '2rem' }} />
    );
  }

  const pagesCount = Math.ceil(size(allCantJoinRoom) / pageSize);
  console.log(allCantJoinRoom, 'check cant join room');

  return (
    <Fragment>
      <UncontrolledPopover popperClassName="popover" placement="right" trigger="focus" target="admin-help-button-events-banner">
        <PopoverBody className="popover-body">
          This opens a page where we show a list of cases when the player was not able to join or create a room. This is useful for the admin to see if there are any issues with the room creation or joining process.
        </PopoverBody>
      </UncontrolledPopover>
      <div className="admin-page-content">
        <Row>
          <Col sm="4">
            <h2>
              Can't Join Room
              <Button className="admin-help-button" id="admin-help-button-events-banner">
                ?
              </Button>
            </h2>
          </Col>
          <Col sm="8">
            {allCantJoinRoom
            && (
            <h3 style={{ display: 'inline-block', marginLeft: 30 }}>
              Filtered
              {' '}
              {Object.keys(allCantJoinRoom).length}
              {' '}
              rooms out of
              {' '}
              {allCantJoinRoomCount}
              {' '}
              total
            </h3>
            )
          }
          </Col>
        </Row>
        <Row className="mb-4">
          <Col sm="12">
            <Row>
              <Col sm="1">
                <Label for="actionType">
                  Action Type
                </Label>
                <Input type="select" className="game-bet-select" value={actionType} onChange={selectActionType}>
                  <option value="all">All</option>
                  <option value="create">Create</option>
                  <option value="join">Join</option>
                </Input>
              </Col>
              <Col sm="2">
                <Label for="reason">
                  Reason
                </Label>
                <Input type="select" className="game-bet-select text-captialize" value={reason} onChange={selectReason}>
                  <>
                    <option value="all">All</option>
                    {CANT_JOIN_ROOM_REASON.map(item => (
                      <option value={item}>{item}</option>
                    ))}
                  </>
                </Input>
              </Col>
              <Col sm="2">
                <Label for="filterType">
                  Search by
                </Label>
                <Input type="select" className="game-bet-select" value={filterType} onChange={selectType}>
                  <option value="userId">Player Id</option>
                  <option value="playerName">Player Name</option>
                </Input>
              </Col>

              <Col sm="2">
                <Label for="filter">
                  Value
                </Label>
                <Input
                  type="text"
                  name="filter"
                  id="filter"
                  value={filter}
                  onChange={handleChange}
                  onKeyPress={handleKeyPress}
                />
              </Col>
              <Col sm="2">
                <Label for="startDate">
                  From
                </Label>
                <Row>
                  <Col md="12">
                    <DateTimePicker
                      format="DD.MM.YYYY HH:mm"
                      culture="en"
                      onChange={date => changeStartDate(date)}
                      value={startDate}
                      defaultValue={new Date(Date.now() - 24 * 60 * 60 * 1000)}
                    />
                  </Col>
                </Row>
              </Col>
              <Col sm="2">
                <Label for="endDate">
                  To
                </Label>
                <Row>
                  <Col md="12">
                    <DateTimePicker
                      format="DD.MM.YYYY HH:mm"
                      culture="en"
                      onChange={changeEndDate}
                      value={endDate}
                      defaultValue={new Date()}
                    />
                  </Col>
                </Row>
              </Col>
              <Col sm="1" className="d-flex flex-column justify-end">
                {isReset && (
                  <Button className="mb-1" onClick={() => resetFilters()}>
                    Reset
                  </Button>
                ) }
                <Button onClick={() => filterFunc()}>
                  Filter
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <table className="w-full fs-4">
          <colgroup>
            <col span="1" className="" />
          </colgroup>
          <thead>
            <tr>
              <th className="text-center">
                Player ID
              </th>
              <th className="text-center">
                Player Name
              </th>
              <th className="text-center">
                Platform
              </th>
              <th className="text-center">
                Action Type
              </th>
              <th className="text-center">
                Date and Time
              </th>
              <th className="text-center">
                Room ID(for joining a room)
              </th>
              <th className="text-center">
                Reason
              </th>
            </tr>
          </thead>
          <tbody>
            {size(allCantJoinRoom) > 0 && Object.keys(allCantJoinRoom)
              .sort((a, b) => allCantJoinRoom[b].date - allCantJoinRoom[a].date)
              .slice(
                currentPage * pageSize,
                (currentPage + 1) * pageSize,
              )
              .map((key, index) => (
                <Fragment key={key}>
                  <tr className={`allUsers-table-row ${index % 2 === 0 ? ('odd') : ('even')}`}>
                    <td className="allUsers-table-col">
                      {allCantJoinRoom[key].playerId}
                    </td>
                    <td className="allUsers-table-col">
                      {allCantJoinRoom[key].playerName}
                    </td>
                    <td className="allUsers-table-col">
                      {renderPlatformIcon(allCantJoinRoom[key].platform)}
                    </td>
                    <td className="allUsers-table-col">
                      {allCantJoinRoom[key].actionType}
                    </td>
                    <td className="allUsers-table-col">
                      {allCantJoinRoom[key].date && (
                        <DateFormat formatType={FORMAT_DATE_TYPE.fullDateSecond} date={allCantJoinRoom[key].date + offset} />
                      )}
                    </td>
                    <td className="allUsers-table-col">
                      {allCantJoinRoom[key].roomId}
                    </td>
                    <td className="allUsers-table-col">
                      {allCantJoinRoom[key].reason}
                    </td>
                  </tr>
                </Fragment>
              ))}
          </tbody>
        </table>
        <div className="pagination-wrapper">
          <Pagination aria-label="Page navigation example">
            <PaginationItem disabled={currentPage === 0}>
              <PaginationLink style={{ color: '#000' }} onClick={e => handleClick(e, 0)} href="#">
                ‹‹‹
              </PaginationLink>
            </PaginationItem>

            <PaginationItem disabled={currentPage <= 0}>
              <PaginationLink
                style={{ color: '#000' }}
                onClick={e => handleClick(e, currentPage - 1)}
                previous
                href="#"
              />
            </PaginationItem>

            {[...Array(pagesCount)].map((page, i) => {
              if (i > currentPage - 4 && i < currentPage + 4) {
                return (
                  <PaginationItem active={i === currentPage} key={page}>
                    <PaginationLink style={{ color: '#000' }} onClick={e => handleClick(e, i)} href="#">
                      {i + 1}
                    </PaginationLink>
                  </PaginationItem>
                );
              }

              return null;
            })}

            <PaginationItem disabled={currentPage >= pagesCount - 1}>
              <PaginationLink
                style={{ color: '#000' }}
                onClick={e => handleClick(e, currentPage + 1)}
                next
                href="#"
              />
            </PaginationItem>

            <PaginationItem disabled={currentPage >= pagesCount - 1}>
              <PaginationLink style={{ color: '#000' }} onClick={e => handleClick(e, pagesCount - 1)} href="#">
                ›››
              </PaginationLink>
            </PaginationItem>
          </Pagination>
        </div>
      </div>
    </Fragment>
  );
};

export default AllPlayersHistoryToJoinRoom;
